exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-blanco[data-v-6ac0ce6b]{padding-bottom:100px}.label-radio[data-v-6ac0ce6b]{margin-right:10px}.is-radio-input[data-v-6ac0ce6b]{padding-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ac0ce6b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sca_Componentes/tpa/cuartocontrol/Subgrupos.vue
// module id = 3813
// module chunks = 0